import { MATERIAL_SYMBOLS_ICON_MAP, fuzeHealthIconColorVariants } from '@alto/design-library-tokens';
import React from 'react';
import { MaterialSymbolIcon, type MaterialSymbolIconBrandProps } from './MaterialSymbolIcon.web';

export const FuzeHealthIcon = (props: MaterialSymbolIconBrandProps) => {
  return (
    <MaterialSymbolIcon
      {...props}
      colorVariants={fuzeHealthIconColorVariants}
      iconMap={MATERIAL_SYMBOLS_ICON_MAP}
    />
  );
};
